/*
 * @Author: Teemo Ding
 * @Date: 2021-10-15 16:09:49
 * @LastEditTime: 2021-10-18 09:50:10
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/MiniProgramNavigationBar/index.tsx
 */
import React from 'react';

import { store } from 'src/store';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import TwitterColorPicker from 'src/components/ColorPicker/TwitterColorPicker';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getMiniProgramNavigationBarButtonStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onMiniProgramNavigationBarChange,
  onMiniProgramNavigationBarReset,
} from '../slice';

const idSet = {
  backgroundColour: suffix + 'miniProgramNavigationBarbackgroundColour',
  textColour: suffix + 'miniProgramNavigationBarFrontColour',
};
const MiniProgramNavigationBar = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { backgroundColor, fontColor } = data || {};

  const _d = useDispatch();

  const handleOnBkgChange = (backgroundColor) => {
    _d(onMiniProgramNavigationBarChange({ backgroundColor }));
  };

  const handleOnTextChange = (fontColor) => {
    _d(onMiniProgramNavigationBarChange({ fontColor }));
  };

  return (
    <React.Fragment>
      <Section>
        <ItemWrapper
          id={idSet.backgroundColour}
          title={getI18n('general.backgroundColour')}>
          <ColorPicker
            id={idSet.backgroundColour}
            onChange={handleOnBkgChange}
            multi
            color={backgroundColor}
          />
        </ItemWrapper>
        <ItemWrapper
          id={idSet.textColour}
          title={getI18n('general.textColour')}>
          <TwitterColorPicker
            onChange={handleOnTextChange}
            id={idSet.textColour}
            color={fontColor}
          />
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(MiniProgramNavigationBar, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.miniProgramNavigationBar,
  getContent: getMiniProgramNavigationBarButtonStyle,
  title: getI18nFromGeneral('general.hOCTitle.miniProgramNavigationBar'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onMiniProgramNavigationBarReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
